import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react";
import type { SortField, SortDirection } from "./categoryUtils";

interface CategoryTableHeaderProps {
  sortField: SortField;
  sortDirection: SortDirection;
  onSort: (field: SortField) => void;
  isDraggable: boolean;
}

function SortIcon({ field, currentField, direction }: { field: SortField; currentField: SortField; direction: SortDirection }) {
  if (currentField !== field) {
    return <ArrowUpDown className="ml-1 h-4 w-4 text-ink-400" />;
  }
  return direction === "asc" ? (
    <ArrowUp className="ml-1 h-4 w-4 text-ink-600" />
  ) : (
    <ArrowDown className="ml-1 h-4 w-4 text-ink-600" />
  );
}

export function CategoryTableHeader({
  sortField,
  sortDirection,
  onSort,
  isDraggable,
}: CategoryTableHeaderProps) {
  return (
    <thead>
      <tr className="border-b border-grid-200 bg-grid-50">
        {isDraggable && (
          <th className="w-10 px-2 py-4 text-left">
            <button
              onClick={() => onSort("order")}
              className="flex items-center text-xs font-semibold uppercase tracking-wider text-ink-600 hover:text-ink-900"
            >
              <SortIcon field="order" currentField={sortField} direction={sortDirection} />
            </button>
          </th>
        )}
        <th className="px-6 py-4 text-left">
          <button
            onClick={() => onSort("name")}
            className="flex items-center text-xs font-semibold uppercase tracking-wider text-ink-600 hover:text-ink-900"
          >
            Category
            <SortIcon field="name" currentField={sortField} direction={sortDirection} />
          </button>
        </th>
        <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider text-ink-600">
          Icon
        </th>
        <th className="px-6 py-4 text-left">
          <button
            onClick={() => onSort("attributesCount")}
            className="flex items-center text-xs font-semibold uppercase tracking-wider text-ink-600 hover:text-ink-900"
          >
            Attributes linked
            <SortIcon field="attributesCount" currentField={sortField} direction={sortDirection} />
          </button>
        </th>
        <th className="px-6 py-4 text-right text-xs font-semibold uppercase tracking-wider text-ink-600">
          Actions
        </th>
      </tr>
    </thead>
  );
}
